import { useQuery } from 'react-query';

import { getCardResourceTypes as queryFn } from 'api/endPoints/getCardResourceTypes';
import { IVersion } from 'api/queries/getProjectVersionsList.query';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetCardResourceTypes = (params: QueryParams) => {
    return useQuery<ICardResourceTypes[], QueryError, ICardResourceTypes[], [QueryKeys, unknown]>({
        queryKey: ['getCardResourceTypes', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId),
    });
};

export interface QueryParams {
    metaDataId?: IVersion['id'];
}

export interface ICardResourceTypes {
    name: number;
    label: string;
}
